﻿import CloseIcon from "@mui/icons-material/Close";
import { Box, Chip, Grid as Grid2, IconButton, Modal, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import Colors, { lightenHexColor } from "../../assets/helpers";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function WorkPackageInfoModal({ open = false, onClose = () => { }, data }) {
  const { selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientWorkPackageInfoModal(
    multiLanguageData?.ClientWorkPackageInfoModal || {}
  );
  const {
    TEXT_JOB,
    TEXT_FOREMAN,
    TEXT_CREW_SIZE,
    TEXT_MEASURED_AREA,
    TEXT_RATE_OF_MEASURE,
    TEXT_PLANNED_START_DATE,
    TEXT_PLANNED_END_DATE,
    TEXT_DESCRIPTION,
    TEXT_ITEMS
  } = LANGUAGE;
  const AccentColor = selectedClientData?.AccentColor;
  return (
    <Modal open={open} onClose={onClose}>
      <Box className={"client-modal-responsive"}>
        <Stack spacing={1} sx={{ padding: 1 }}>
          <Box sx={{ justifyContent: "space-between", display: "flex" }}>
            <Stack spacing={1}>
              <Typography sx={{ fontWeight: "bold" }} variant="h5">
                {data?.name}
              </Typography>
              <span>
                <Chip
                  size="small"
                  label={data?.statusName}
                  sx={{
                    padding: "5px 2px",
                    borderRadius: "5px"
                  }}
                />
              </span>
            </Stack>
            <span>
              <IconButton size="small" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </span>
          </Box>

          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <Typography
                variant="body1"
                sx={{
                  color: Colors.TaupeGray
                }}>
                {TEXT_JOB}
              </Typography>
              <Typography variant="body1">
                {data?.jobCode}-{data?.jobName}
              </Typography>
            </Grid2>
            <Grid2 size={3}>
              <Typography
                variant="body1"
                sx={{
                  color: Colors.TaupeGray
                }}>
                {TEXT_FOREMAN}
              </Typography>
              <Typography variant="body1">{data?.foremanName}</Typography>
            </Grid2>
            <Grid2 size={3}>
              <Typography
                variant="body1"
                sx={{
                  color: Colors.TaupeGray
                }}>
                {TEXT_CREW_SIZE}
              </Typography>
              <Typography variant="body1">{data?.crewSize}</Typography>
            </Grid2>
            <Grid2 size={3}>
              <Typography
                variant="body1"
                sx={{
                  color: Colors.TaupeGray
                }}>
                {TEXT_MEASURED_AREA}
              </Typography>
              <Typography variant="body1">{data?.measuredArea}</Typography>
            </Grid2>
            <Grid2 size={3}>
              <Typography
                variant="body1"
                sx={{
                  color: Colors.TaupeGray
                }}>
                {TEXT_RATE_OF_MEASURE}
              </Typography>
              <Typography variant="body1">{data?.rateOfMeasure}</Typography>
            </Grid2>
            <Grid2 size={3}>
              <Typography
                variant="body1"
                sx={{
                  color: Colors.TaupeGray
                }}>
                {TEXT_PLANNED_START_DATE}
              </Typography>
              <Typography variant="body1">{data?.plannedStartDate}</Typography>
            </Grid2>
            <Grid2 size={3}>
              <Typography
                variant="body1"
                sx={{
                  color: Colors.TaupeGray
                }}>
                {TEXT_PLANNED_END_DATE}
              </Typography>
              <Typography variant="body1">{data?.plannedEndDate}</Typography>
            </Grid2>
            <Grid2 size={12}>
              <Typography
                variant="body1"
                sx={{
                  color: Colors.TaupeGray
                }}>
                {TEXT_DESCRIPTION}
              </Typography>
              <Typography variant="body1">{data?.description}</Typography>
            </Grid2>
            <Grid2 size={12}>
              <Typography variant="h6">{TEXT_ITEMS}</Typography>
            </Grid2>
            <Grid2 size={12}>
              {[data?.itemsRequired, data?.itemsInternal, data?.itemsExternal].filter(Boolean).length === 0 ? (
                <Typography variant="body1">No items available</Typography>) : (<Stack sx={{ gap: 1 }} direction={"row"} flexWrap="wrap" >
                  {[data?.itemsRequired, data?.itemsInternal, data?.itemsExternal]?.map(
                    (item, index) => {
                      return (
                        item && (
                          <Chip
                            key={index}
                            label={`${item}`}
                            size="small"
                            sx={{
                              padding: "5px 7px",
                              borderRadius: "5px",
                              backgroundColor:
                                item == 5 ? lightenHexColor(AccentColor, 90) : Colors.white,
                              color: item == 5 ? AccentColor : Colors.Black,
                              fontWeight: item == 5 ? "bold" : "normal",
                              border: `1px solid ${item == 5 ? AccentColor : Colors.LightGray}`
                            }}
                          />
                        )
                      );
                    }
                  )}
                </Stack>
              )}

            </Grid2>
          </Grid2>
        </Stack>
      </Box>
    </Modal>
  );
}

export default WorkPackageInfoModal;

